// src/index.ts
import { visit } from "unist-util-visit";

// src/Mermaid.tsx
import { useEffect, useId, useState } from "react";
import mermaid from "mermaid";
import { jsx } from "react/jsx-runtime";
var initialized = false;
function Mermaid({ chart }) {
  const id = useId();
  const [svg, setSvg] = useState("");
  useEffect(() => {
    if (!initialized) {
      initialized = true;
      mermaid.initialize({
        fontFamily: "inherit"
      });
    }
    mermaid.render(
      id.replace(/[^a-zA-Z]+/g, ""),
      // strip special chars from useId
      `${chart}`
      // apply theme and supply chart
    ).then(({ svg: svg2 }) => {
      setSvg(svg2);
    }).catch((error) => {
      console.error("Error while rendering mermaid", error);
    });
  }, [id, chart]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "mt-6 flex justify-center",
      dangerouslySetInnerHTML: { __html: svg }
    }
  );
}

// src/index.ts
var FILE_PATH = "remark-mermaid-nextra";
var MERMAID_IMPORT_AST = {
  type: "mdxjsEsm",
  value: `import { Mermaid } from "${FILE_PATH}"`,
  data: {
    estree: {
      type: "Program",
      sourceType: "module",
      body: [
        {
          type: "ImportDeclaration",
          specifiers: [
            {
              type: "ImportSpecifier",
              imported: { type: "Identifier", name: "Mermaid" },
              local: { type: "Identifier", name: "Mermaid" }
            }
          ],
          source: {
            type: "Literal",
            value: FILE_PATH,
            raw: `"${FILE_PATH}"`
          }
        }
      ]
    }
  }
};
var getMermaidElementAST = (value) => ({
  type: "mdxJsxFlowElement",
  name: "Mermaid",
  children: [],
  attributes: [
    {
      type: "mdxJsxAttribute",
      name: "chart",
      value: {
        type: "mdxJsxAttributeValueExpression",
        value: `\`${value}\``,
        data: {
          estree: {
            type: "Program",
            sourceType: "module",
            body: [
              {
                type: "ExpressionStatement",
                expression: {
                  type: "TemplateLiteral",
                  expressions: [],
                  quasis: [
                    {
                      type: "TemplateElement",
                      value: {
                        raw: value,
                        cooked: value
                      },
                      tail: true
                    }
                  ]
                }
              }
            ]
          }
        }
      }
    }
  ]
});
var remarkMermaid = () => (ast, _file, done) => {
  const codeblocks = [];
  visit(ast, { type: "code", lang: "mermaid" }, (node, index, parent) => {
    codeblocks.push([node, index, parent]);
  });
  if (codeblocks.length !== 0) {
    for (const [node, index, parent] of codeblocks) {
      parent.children.splice(index, 1, getMermaidElementAST(node.value));
    }
    ast.children.unshift(MERMAID_IMPORT_AST);
  }
  done();
};
export {
  Mermaid,
  remarkMermaid
};
